export function shouldExitDocumentFullscreenOnLeave({
  isDocumentFullscreen,
  isOnDocument,
}: {
  isDocumentFullscreen: boolean
  isOnDocument: boolean
}): boolean {
  return isDocumentFullscreen && !isOnDocument
}

export function shouldExitDocumentFullscreenOnKey({
  isDocumentFullscreen,
  key,
}: {
  isDocumentFullscreen: boolean
  key: string
}): boolean {
  return isDocumentFullscreen && key === 'Escape'
}
